document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector(".product-template-pop-up");
  const overlay = document.querySelector(".product-template-site-overlay");

  let currentExtraClass = "";

  function togglePopup(open) {
    if (!popup) return;

    if (open) {
      overlay?.classList.add("active");
      popup.classList.add("active");
      document.body.classList.add("active-overlay");
      if (currentExtraClass) popup.classList.add(currentExtraClass);
    } else {
      overlay?.classList.remove("active");
      popup.classList.remove("active");
      document.body.classList.remove("active-overlay");
      if (currentExtraClass) popup.classList.remove(currentExtraClass);
      currentExtraClass = "";
      pauseVideos(popup);
    }
  }

  document.querySelectorAll(".pop-up-button").forEach(function (button) {
    button.addEventListener("click", function () {
      currentExtraClass = button.getAttribute("data-pop-up-class") || "";
      togglePopup(true);
    });
  });

  popup
    ?.querySelector(".product-template-pop-up-header svg")
    ?.addEventListener("click", function () {
      togglePopup(false);
    });

  overlay?.addEventListener("click", function (event) {
    if (event.target === overlay) {
      togglePopup(false);
    }
  });

  function pauseVideos(popup) {
    const allVideos = popup.querySelectorAll("video");

    allVideos.forEach(function (video) {
      video.pause();
      const container = video.closest('.video-container');
      const playIcon = container?.querySelector("svg");
      if (playIcon) {
        playIcon.style.display = "block";
      }
    });
  }

  function initializeVideoControls() {
    const videoContainers = popup?.querySelectorAll(".media-grid-item.media-video.video-container") || [];

    videoContainers.forEach(function (container, index) {
      const video = container.querySelector("video");
      const playIcon = container.querySelector("svg");

      if (!video || !playIcon) return;

      container.removeEventListener("click", container._videoToggleHandler);

      const updatePlayIcon = () => {
        playIcon.style.display = video.paused ? "block" : "none";
      };

      const pauseOtherVideos = (currentVideo) => {
        videoContainers.forEach(function (otherContainer) {
          const otherVideo = otherContainer.querySelector("video");
          const otherPlayIcon = otherContainer.querySelector("svg");
          
          if (otherVideo && otherVideo !== currentVideo && !otherVideo.paused) {
            otherVideo.pause();
            if (otherPlayIcon) {
              otherPlayIcon.style.display = "block";
            }
          }
        });
      };

      const toggleVideo = (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        if (video.paused) {
          pauseOtherVideos(video);
          video.play();
        } else {
          video.pause();
        }
      };

      video.addEventListener("play", updatePlayIcon);
      video.addEventListener("pause", updatePlayIcon);
      video.addEventListener("ended", updatePlayIcon);

      container._videoToggleHandler = toggleVideo;
      container.addEventListener("click", toggleVideo);

      updatePlayIcon();
    });
  }

  initializeVideoControls();
});
